// Setting up Axios in a React.js project
import axios from 'axios';

import {useUserStore} from "../stores/userStore";
import {ApiService} from "../api/ApiService";

export const API_URL = window.location.hostname === "cflow.carolynleepllc.com"
    ? "https://api.cflow.carolynleepllc.com"
    : "https://dev.api.cflow.carolynleepllc.com";

const axiosInstance = axios.create({
    baseURL: API_URL,
});

const axiosInstanceWithToken = axios.create({
    baseURL: API_URL,
});
axiosInstanceWithToken.interceptors.request.use(
    (config) => {
        const token = localStorage.getItem("token");
        if (!token) {
            useUserStore.getState().logout();
            return;
        }
        if (config.headers) {
            config.headers['Authorization'] = `Bearer ${token}`;
        }
        return config;
    },
    (error) => {
        return Promise.reject(error);
    }
);
const refreshAndRetryQueue: any[] = [];

// Flag to prevent multiple token refresh requests
let isRefreshing = false;

axiosInstanceWithToken.interceptors.response.use(
    (response) => response,
    async (error) => {
        const originalRequest = error.config;

        if (error.response && error.response.status === 401) {
            if (!isRefreshing) {
                isRefreshing = true;
                try {
                    const accessToken = localStorage.getItem("token");
                    const refreshToken = localStorage.getItem("refreshToken");
                    if (!accessToken || !refreshToken) {
                        useUserStore.getState().logout();
                        return Promise.reject(error);
                    }
                    const response = await ApiService.RefreshToken(accessToken, refreshToken);
                    if (response.success) {
                        const newAccessToken = response.data.accessToken;
                        localStorage.setItem("token", newAccessToken);
                        localStorage.setItem("refreshToken", response.data.refreshToken);

                        // Повторяем все запросы из очереди
                        refreshAndRetryQueue.forEach(({config, resolve, reject}) => {
                            config.headers['Authorization'] = `Bearer ${newAccessToken}`;
                            axiosInstanceWithToken
                                .request(config)
                                .then(resolve)
                                .catch(reject);
                        });
                        refreshAndRetryQueue.length = 0;

                        // Повторяем исходный запрос
                        originalRequest.headers['Authorization'] = `Bearer ${newAccessToken}`;
                        return axiosInstanceWithToken(originalRequest);
                    } else {
                        useUserStore.getState().logout();
                        return Promise.reject(error);
                    }
                } catch (refreshError) {
                    refreshAndRetryQueue.forEach(({reject}) => reject(refreshError));
                    refreshAndRetryQueue.length = 0;
                    useUserStore.getState().logout();
                    return Promise.reject(refreshError);
                } finally {
                    isRefreshing = false;
                }
            }

            // Add the original request to the queue
            return new Promise((resolve, reject) => {
                refreshAndRetryQueue.push({config: originalRequest, resolve, reject});
            });
        }

        // Return a Promise rejection if the status code is not 401
        return Promise.reject(error);
    }
);
export {axiosInstanceWithToken, axiosInstance};